import { render, staticRenderFns } from "./h5Bottom.vue?vue&type=template&id=71359df6&scoped=true"
import script from "./h5Bottom.vue?vue&type=script&lang=js"
export * from "./h5Bottom.vue?vue&type=script&lang=js"
import style0 from "./h5Bottom.vue?vue&type=style&index=0&id=71359df6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71359df6",
  null
  
)

export default component.exports